function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M496,248a8,8,0,0,0,8-8V208a8.033,8.033,0,0,0-3.56-6.66l-240-160a8.013,8.013,0,0,0-8.88,0l-240,160A8.033,8.033,0,0,0,8,208v32a8,8,0,0,0,8,8H32V456H16a8,8,0,0,0,0,16H496a8,8,0,0,0,0-16H480V248ZM288,456H96v-8H288Zm0-24H96v-8H288Zm0-24H96v-8H288Zm0-24H96v-8H288Zm0-24H96v-8H288Zm0-24H96v-8H288ZM80,312V296H304v16ZM424,456H360V336h64Zm40,0H440V328a8,8,0,0,0-8-8H352a8,8,0,0,0-8,8V456H304V328h8a8,8,0,0,0,8-8V288a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8v32a8,8,0,0,0,8,8h8V456H48V244.15L256,97.78,464,244.15Zm10.53-224L260.6,81.46a7.965,7.965,0,0,0-9.2,0L37.47,232H24V212.28L256,57.61,488,212.28V232Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408,376a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V384A8,8,0,0,0,408,376Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M256,152a48,48,0,1,0,48,48A48.054,48.054,0,0,0,256,152Zm0,80a32,32,0,1,1,32-32A32.036,32.036,0,0,1,256,232Z"
}));

function SvgGarage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/garage.a5443abc.svg";
export { ForwardRef as ReactComponent };